import getConversationReadingPaneViewState from "./getConversationReadingPaneViewState";
import type ItemPartViewState from "owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState";
import initializeExtendedStateForItemViewState from "owa-mail-reading-pane-store/lib/actions/initializeExtendedStateForItemViewState";

export default async function initializeExtendedStateForExpandedItemParts(conversationId: string): Promise<void> {
    const loadedConversationItemParts = getConversationReadingPaneViewState(conversationId)?.itemPartsMap;
    loadedConversationItemParts?.forEach((itemPart: ItemPartViewState) => {
        if (itemPart.isExpanded) {
            initializeExtendedStateForItemViewState(itemPart);
        }
    });
}
